<template>
    <div class="profile-media-gallery--blocks" v-if="hasPremiumContent || freeVideoCount">
        <div v-if="aggregatedTotals.photoQuantity" class="profile-media-gallery--section"
             @click.prevent="onGalleryClick">
            <div>
                <icon-component :icon="fa_gem()" width="40px" height="40px" class="icon-diamond"/>
                <span>{{ premiumPhotosLabel }}</span>
            </div>

            <picture>
                <source :srcset="gallery.defaultPhoto.urls.jpg" type="image/jpg">
                <img :alt="'Photo'" :src="gallery.defaultPhoto.urls.jpg">
            </picture>
        </div>
        <div class="profile-media-gallery--section" v-if="aggregatedTotals.videoQuantity && isVideoUploadEnabled"
             @click.prevent="onGalleryClick">
            <div>
                <icon-component :icon="fa_video_play()" width="40px" height="40px" class="icon-diamond"/>
                <span>{{ premiumVideosLabel }}</span>
            </div>

            <picture>
                <source :srcset="premiumVideoThumbnail" type="image/jpg">
                <img :alt="'Video'" :src="premiumVideoThumbnail">
            </picture>
        </div>
        <div class="profile-media-gallery--section" v-if="freeVideoCount && isVideoUploadEnabled"
             @click.prevent="onFreeVideoClick">
            <div>
                <icon-component :icon="fa_video_play()" width="40px" height="40px"/>
                <span>{{ freeVideosLabel }}</span>
            </div>

            <picture v-if="freeVideoThumbnail">
                <img :alt="'Video'" :src="freeVideoThumbnail">
            </picture>
        </div>
    </div>
</template>

<script>

import userMixin from "@/components/mixins/userMixin";
import photoMixin from "@/components/mixins/photoMixin";
import IconComponent from "@/components/global/IconComponent.vue";
import {fa_gem, fa_video_play} from "@/core/constants/icons";

export default {
    components: {IconComponent},
    computed: {
        ...mapState(['currentUser', 'translate', 'regionData']),
        isVideoUploadEnabled() {
            return !_.has(this.regionData, 'sectionsToHide.videoUpload');
        },
        allGalleries() {
            return _.get(this, 'user.galleries', []).filter(g => g.defaultPhoto || g.videoThumbnail);
        },
        hasMultipleGalleries() {
            return this.allGalleries.length > 1;
        },
        aggregatedTotals() {
            return this.allGalleries.reduce((acc, g) => ({
                photoQuantity: acc.photoQuantity + (g.photoQuantity || 0),
                videoQuantity: acc.videoQuantity + (g.videoQuantity || 0),
            }), {photoQuantity: 0, videoQuantity: 0});
        },
        gallery() {
            return this.allGalleries.find(g => g.defaultPhoto) || this.allGalleries[0] || null;
        },
        hasPremiumContent() {
            return this.gallery && (this.aggregatedTotals.photoQuantity || this.aggregatedTotals.videoQuantity);
        },
        premiumPhotosLabel() {
            if (this.aggregatedTotals.photoQuantity > 1) {
                return this.translate.product.galleryPremiumPhotos[1];
            }
            return this.translate.product.galleryPremiumPhotos[0];
        },
        premiumVideosLabel() {
            if (this.aggregatedTotals.videoQuantity > 1) {
                return this.translate.product.galleryPremiumVideos[1];
            }
            return this.translate.product.galleryPremiumVideos[0];
        },
        freeVideosLabel() {
            if (this.freeVideoCount > 1) {
                return this.translate.product.galleryFreeVideos[1];
            }
            return this.translate.product.galleryFreeVideos[0];
        },
        premiumVideoThumbnail() {
            const galleryWithVideo = this.allGalleries.find(g => g.videoThumbnail);
            if (galleryWithVideo) {
                return galleryWithVideo.videoThumbnail;
            }
            return _.get(this.gallery, 'defaultPhoto.urls.jpg');
        },
        freeVideos() {
            return _.get(this, 'user.videos', []).filter(v => v.is_uploaded);
        },
        freeVideoCount() {
            return this.freeVideos.length;
        },
        freeVideoThumbnail() {
            const video = this.freeVideos[0];
            if (!video) {
                return null;
            }
            if (video.thumbnail) {
                return video.thumbnail;
            }
            return this.getPhotoUrl(this.user, 'jpg', 'medium');
        },
    },
    props: {
        user: {
            type: Object,
            default: null,
        },
    },
    methods: {
        fa_video_play,
        fa_gem,
        onGalleryClick() {
            if (this.hasMultipleGalleries) {
                this.$emit('gallerySubscribeClick', null);
                return;
            }
            this.$emit('gallerySubscribeClick', this.gallery);
        },
        onFreeVideoClick() {
            this.$emit('freeVideoClick');
        },
    },
    mixins: [
        userMixin,
        photoMixin,
    ],
}
</script>
